<script>
import pagination from "@/components/pagination";
import dataTableActions from "@/components/dataTableActions";

export default {
  name: "data-table",
  components: {
    pagination,
    dataTableActions,
  },
  props: {
    columns: Array,
    dataSource: String,
    includeHeader: Boolean,
    noDataDescription: String,
    filterText: String,
    defaultPageSize: Number,
    refresh: 0,
    idField: String,
    deleteWarning: String,
    rowTitle: String
  },
  data: function() {
    return {
      page: 1,
      filter: "",
      pageData: [],
      totalItemCount: 0,
      pageSize: this.defaultPageSize || 10,
      activeItem: "",
      showActions: false,
    };
  },
  methods: {
    async getData() {
      var response = await this.$store.dispatch("getRequest", { controller: this.dataSource, parameters: { page: this.page, pageSize: this.pageSize, filter: this.filter } });
      this.totalItemCount = response.total;
      this.pageData = response.data;
    },
    setPage: function(page) {
      this.page = page;
    },
    setPageSize: function(pageSize) {
      this.pageSize = pageSize;
    },
    onRowClick: function(id) {
      this.$emit("onRowClick", id);
    },
    onActionClick: function(itemId) {
      this.activeItem = itemId;
      this.showActions = true;
    },
    onHideActions: function(itemId) {
      this.activeItem = "";
      this.showActions = false;
    },
    onEdit: function() {
      this.$emit("edit", this.activeItem);
    },
    onDelete: function() {
      var status = this.getField(this.activeItem, "status");
      this.$emit("delete", this.activeItem, status);
    },
    getField: function(id, field) {
      var idField = this.idField;
      return this.pageData.filter(function(x) {
        return x[idField] == id;
      })[0][field];
    },
  },
  computed: {
        isMobile: function() {
      return this.$store.state.isMobile;
    },
  },
  mounted: function() {
    this.getData();
  },
  watch: {
    filter: function() {
      this.page = 1;
    },
    page: function() {
      this.getData();
    },
    refresh: function() {
      this.getData();
    },
  },
};
</script>
<template>
  <div>
    <div v-if="includeHeader">
      <input v-model="filter" style="width:auto;display:inline-block" class="search-bar form-control" :placeholder="filterText ? filterText : 'Filter...'" />
    </div>
    <table class="table" :class="[isMobile ? 'mobile' : '']">
      <thead></thead>
        <tr class="d-flex">
          <th v-for="col in columns" :key="`${col.field}-header`" :class="col.class">{{ col.title }}</th>
        </tr>
      </thead>
      <tbody v-if="pageData.length">
        <tr v-for="(item, index) in pageData" :key="`row-${index}`" class="d-flex" :title="rowTitle || ''">
          <td v-for="(col, colIndex) in columns" :key="`${colIndex}-${col.field}-header`" :class="col.class" v-on:click.stop="col.type == 'action' ? onActionClick(item[idField]) : onRowClick(item.id)">
            <span v-if="col.type == 'action'"><i title="Actions" class="fas fa-ellipsis-v hoverable float-right"></i></span>
            <span v-else-if="col.type == 'status'" :class="`status-${item[col.field].replace(/\s/g, '-').toLowerCase()}`">{{ item[col.field] }}</span>
            <span v-else>{{ item[col.field] }}</span>
          </td>
        </tr>
      </tbody>
      <tbody v-else>
        <div style="text-align:center;width:100%">
          <span v-if="noDataDescription">{{ noDataDescription }}</span>
          <span v-else>No data to show!</span>
        </div>
      </tbody>
    </table>
    <pagination v-if="totalItemCount > pageSize" v-bind:showPageSize="false" pages-to-show="5" v-on:set-page="setPage" v-on:setPageSize="setPageSize" v-bind:current-page="page" v-bind:item-count="totalItemCount" v-bind:page-size="pageSize"></pagination>
    <data-table-actions v-on:edit="onEdit" v-on:delete="onDelete" v-on:hideActions="onHideActions" :isEdit="showActions" :deleteWarning="deleteWarning"></data-table-actions>
  </div>
</template>
<style scoped>
[class*="status"] {
 font-size:12px;
}
.table.mobile {
  font-size:12px;
}
tr td {
  color:#004996;
}
tr:hover td{
  background-color:#f0f2f3;
  cursor:pointer!important;
}
</style>

